module.exports = __webpack_public_path__ + "static/media/termopary3kz.4875336a.pdf";